import { buildAccessibilityStatement } from '@gjl/site-kit'
import { ACCESSIBILITY_OPTIONS } from '../legal-options'
import { LegalPage } from './LegalPage'

/** Companion to the privacy policy; same generator, same bespoke shell. */
export default function AccessibilityPage() {
  return <LegalPage doc={buildAccessibilityStatement(ACCESSIBILITY_OPTIONS)} />
}
